export enum PurchaseOrdersRoute {
  Index = '/manual-po',
  Draft = '/manual-po/draft',
  Submitted = '/manual-po/submitted',
  Create = '/manual-po/create',
  View = '/manual-po/:purchaseOrderId'
}
